import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent {
  @Input() label: string = '';
  selectedOption: string = '';
  options: string[] = ['Option 1', 'Option 2'];

  onSelect(option: string): void {
    this.selectedOption = option;
  }
}
